/* global document */
import $ from 'jquery';
import 'html5';
import 'page-scroll-to-id';
import 'remodal';
import 'slick-carousel';
import 'icheck';

import './js/numscroller-1.0';
import './js/global';
import Nette from './js/validation';

import './index.scss';


Nette.initOnLoad();

$(() => {
	$('.eu-cookies button').click(() => {
		const date = new Date();
		date.setFullYear(date.getFullYear() + 10);
		document.cookie = `eu-cookies-roletikcom=1; path=/; expires=${date.toGMTString()}`;
		$('.eu-cookies').hide();
	});
});

$('form').submit((event) => {
	const recaptcha = $('#g-recaptcha-response').val();
	if (recaptcha === '') {
		event.preventDefault();
		$('#recaptcha-error').show();
	}
});



// WEBPACK FOOTER //
// ./frontend/index.js